var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('vx-tooltip',{staticClass:"cursor-pointer flex items-center",attrs:{"text":_vm.$t(`$Enums.Sender.Caller.Type.${_vm.type}`)}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"svgClasses":"h-5 w-5 hover:text-primary"}})],1),_c('span',{staticClass:"ml-3"},[_vm._v(" "+_vm._s(_vm.phoneNumber)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }